<template>
  <div class="PageFooter">
    <div class="mian">
      <div>
        <div class="title">{{ $t("main.contactUs") }}</div>
        <div>
          <img src="../assets/svg/phone.svg" alt="" />
          <span>{{ $t("main.phone") }}：+852 93253164</span>
        </div>
        <div>
          <img src="../assets/svg/email.svg" alt="" />
          <span>{{ $t("main.mailbox") }}：enquiry@kubuqiaward.com</span>
        </div>
      </div>
      <div>
        <div class="title">{{ $t("main.YiliPublicWelfareFoundation") }}</div>
        <!-- <p>{{ $t("main.filingNumber") }}：1234567891234556</p> -->
        <p>{{ $t("main.contactAddress") }}：{{ $t("main.contactAddressDetaile") }}</p>
        <p>
          {{ $t("main.notice_info") }}
        </p>
        <p>
          {{ $t("main.RightOfInterpretation") }}
        </p>
      </div>
      <div class="right">
        <div class="title">{{ $t("main.socialMedia") }}</div>
        <div class="external-link">
          <span @click="externalLink('https://www.instagram.com/thekubuqiaward/')">
            <img src="../assets/svg/socialMedia/instagram-white.svg" alt="" />
            <!-- <span>instagram</span> -->
          </span>
          <span @click="externalLink('https://www.facebook.com/TheKubuqiAward')">
            <img src="../assets/svg/socialMedia/facebook-white.svg" alt="" />
            <!-- <span>facebook</span> -->
          </span>
          <span @click="externalLink('https://wa.me/message/NFY2RYVQMYMPM1')">
            <img src="../assets/svg/socialMedia/whatsapp-white.svg" alt="" />
            <!-- <span>whatsapp</span> -->
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    // 跳转外部链接
    externalLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.PageFooter {
  min-height: 180px;
  background: #000;
  color: #fff;
  min-width: 1400px;

  .mian {
    width: 1400px;
    margin: 0 auto;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;

    > div {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #ffffff;
        margin-bottom: 20px;
      }

      p,
      div {
        margin-bottom: 10px;

        img {
          margin-right: 10px;
        }

        img,
        span {
          vertical-align: middle;
        }
      }
    }
    > div:nth-child(2) {
      max-width: 822px;
    }

    .right {
      .external-link {
        > span {
          display: inline-block;
          // width: 136px;
          // height: 34px;
          // border-radius: 3px;
          // border: 1px solid #FFFFFF;
          margin-left: 22px;
          cursor: pointer;

          &:nth-child(1) {
            margin-left: 0;
          }

          text-align: center;

          img,
          span {
            line-height: 34px;
          }

          img {
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
